module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/desktop-app-1-a413f45d426aca1813829f0986d797b2.png";